import $ from 'jquery';
import breaky from 'breaky';
import search from 'modules/search';
import wishlistCountUpdater from 'modules/wishlist-count-updater';
import liveChat from 'modules/live-chat';
import throttle from 'lodash/throttle';
function initSearch() {
    search.init();
}

$(function () {
    initSearch();
});

wishlistCountUpdater.init();
liveChat.init();

$(function() {
    const rcProps = window.rcProps || {};
    if (rcProps.navigation && rcProps.navigation.dropdownHref) {
        $.getJSON(rcProps.navigation.dropdownHref, (data) => {
            for (const key in data) {
                $('#' + key).replaceWith(data[key]);
            }
            $('.js-dropdown').dropdown();
            $('.js-double-tap-main').doubleTapToGo({
                selectorClass: "js-dropdown"
              });
        });
    }

    var $container = $('#header-search');
    var $button = $container.find('.header-search__icon');
    var $buttonCircle = $button.find('.btn.btn--circle')
    var $inputWrap = $container.find('.header-search__field-wrap');
    var $textField = $(".header-search__field-text.tt-input");
    var $form = $("#header-search-form");

    var fieldMaxWidth = 420;
    var isVisible = false;

    function initSearchField() {
        addEventListeners();
    }

    function addEventListeners() {
        $button.on('click', handleClick);
        $textField.on('keydown', handleEscapeKey);
        $textField.on('blur', handleBtnCopyUpdate);
    }

    function handleBtnCopyUpdate() {
        var closeCopy = $button.data('closeSearch');
        var submitCopy = $button.data('submitSearch');
        var $btnUpdateCopy = $button.find('#search-copy-update');
        if($textField.val()) {
            $btnUpdateCopy.html(submitCopy);
        } else {
            $btnUpdateCopy.html(closeCopy);
        }
    }

    function handleEscapeKey(e) {
        var isEscape = false;
        e = e || window.event;
        if ("key" in e) {
            isEscape = (e.key == "Escape" || e.key == "Esc");
        } else {
            isEscape = (e.keyCode == 27);
        }
        if (isEscape) {
            closeSearch();
        }
        if(e.keyCode == 13){
            e.preventDefault();
            $("#header-search-form").submit();
        }
    }

    function closeSearch() {
        toggleField({ onClose: function() {
            $('.header-search__field-text').val('').trigger('input');
        }}, true);
    }

    function addOpenListeners() {
        $('body').on('click.search.active', function(e) {
            if($(e.target).closest($container).length === 0) {
                closeSearch();
            }
        });
    }

    function handleClick(e) {
        e.preventDefault();
        if($textField.val()) {
            $form.submit();
        } else {
            toggleField();
        }
    }

    function activeClasses() {
        if(isVisible) {
            $button.removeClass('active');
        } else {
            $button.addClass('active');
        }
    }

    function toggleField(opts, forceClose) {
        var closeCopy = $button.data('closeSearch');
        var openCopy = $button.data('openSearch');
        var $btnUpdateCopy = $button.find('#search-copy-update');
        if(forceClose) {
            isVisible = true;
        }
        $inputWrap.css({ display: "inline-block" });
        if (!isVisible) {
            $textField.trigger('focus');
            $btnUpdateCopy.text(closeCopy);
        } else {
            $btnUpdateCopy.text(openCopy);
        }
        $inputWrap.stop().animate({
            width: isVisible ? 0 : fieldMaxWidth,
        }, 600, function() {
            toggleComplete(opts);
        });
        activeClasses();

        isVisible = !isVisible;
    }

    function toggleComplete(opts) {
        var defaults = {
            onClose: function(){}
        }
        var val = $.extend({}, defaults, opts);
        if(isVisible) {
            // Open Field 
            addOpenListeners()
        } else {
            // Close Field
            $inputWrap.hide();
            $button.focus();
            val.onClose();
            $('body').off('click.search.active');
        }
    }
    initSearchField();

    // Visual Search Placement Functionality
    var isiPad = navigator.userAgent.indexOf('iPad') != -1;
    var headerUtility = $("#js-header__utility");
    var headerMainContent = $("#js-header__main-content");

    // breaky.below("small-desktop", function() {
    //   $container.prependTo(headerMainContent);
    // });

    $('html').addClass( (isiPad ? 'ipad' : 'notIpad') );

    $(window).on('resize', function() {
        breaky.below("small-desktop", function() {
          $container.prependTo(headerMainContent);
          $buttonCircle.addClass('btn--white');
        });
        breaky.above("small-desktop", function() {
          $container.appendTo(headerUtility);
            $buttonCircle.removeClass('btn--white');
        });
    }).resize();
});

$(document).ready(function() {
    $('.js-focus-to-search').on('click', function() {
        $('.header-search__icon').click();
        $('#search_term_new').focus();
    })   

    $('.js-set-currency').click(function(e){
        e.preventDefault();
        var currency = $(this).data('currency');
        if(currency){
            var data = 'currency=' + currency;
            $.ajax({
                type: 'POST',
                url: '/r/ajax/SetCurrency.jsp?site=f',
                data: data,
                success: function(data){
                    var obj = $.parseJSON(data);
                    if (obj.success){
                        location.reload();
                    }
                }
            });
        }
    });

    $('.js-set-language').click(function(e){
       e.preventDefault();
       var language = $(this).data('language');
       if(language){
           var data = 'language=' + language;
           $.ajax({
               type: 'POST',
               url: '/r/ajax/SetLanguage.jsp',
               data: data,
               success: function(data){
                   var obj = $.parseJSON(data);
                   if (obj.success){
                       location.reload();
                   }
               }
           });
       }
    });

    $(".js-header-signout").click(function (e) {
        e.preventDefault();

        try {
            if(typeof(crdl) != 'undefined' && crdl != null) {
                crdl('forget');
            }
        } catch(e) {
            console.log(e);
        }
        $.ajax({
            type: 'POST',
            url: '/r/ajax/SignOut.jsp?fw=true',
            success: function(data){
                var obj = $.parseJSON(data);
                if (obj.success){
                    location.reload();
                } else {
                    alert ("Error logging out");
                }
            }
        });

    });
    $(".js-close-banner").click(function (e) {
        e.preventDefault();
        var el = $(".banner--slider-list__item.slick-active");
        if($(".banner--slider-list__item.slick-active").find('.cookie-banner-slide').length) {
            if (typeof cookiesClose === "function") {
                $('.js-slideshow').slick('slickRemove', $('.slick-slide').index(el) - 1);
                cookiesClose();
                el.remove();
            }
        } else {
            if($('.js-slideshow').find('.cookie-banner-slide').length) {
                $('.cookie-banner-global').show();
            }
            $('.js-close-parent').hide().remove();
            $.post("/r/ajax/SetRevolveSessionParam.jsp", $.param({
                "key": "fglobalbannerdismiss",
                "value": "disableglobalbanner"
            }), function () {});
        }
    });

    function calculateMainNavGap() {
        const flexItems = document.querySelectorAll('.nav-primary__list > .nav-primary__item');

        if (flexItems.length < 2) return 0;

        const firstRect = flexItems[0].getBoundingClientRect();
        const secondRect = flexItems[1].getBoundingClientRect();

        const gap = secondRect.left - firstRect.right;

        // Set CSS custom property
        document.documentElement.style.setProperty('--nav-gap', gap + 'px');

        return gap;
    }

    calculateMainNavGap();
    window.addEventListener('resize', throttle(() => calculateMainNavGap(), 100));
});

// Read a page's GET URL variables and return them as an associative array.
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}


// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/index.js